import React, { useEffect, useState } from 'react';
import { Table, Button, Tag, Input, Select, Space, message, Modal, InputNumber } from 'antd';
import { SearchOutlined, CrownOutlined } from '@ant-design/icons';
import request from '../../utils/api';

export default function Members() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [keyword, setKeyword] = useState('');
  const [memberLevel, setMemberLevel] = useState('');
  const [chiefModal, setChiefModal] = useState({ open: false, user: null });
  const [chiefMonths, setChiefMonths] = useState(12);

  useEffect(() => { loadData(); }, [pagination.current, memberLevel]);

  async function loadData() {
    setLoading(true);
    try {
      const res = await request.get('/users/admin/list', {
        params: { page: pagination.current, pageSize: pagination.pageSize, keyword, memberLevel }
      });
      setData(res.data.list);
      setPagination(prev => ({ ...prev, total: res.data.total }));
    } catch (e) {} finally { setLoading(false); }
  }

  async function handleSetChief() {
    try {
      await request.post(`/users/admin/${chiefModal.user.id}/set-chief`, { months: chiefMonths });
      message.success('大酋长已设置');
      setChiefModal({ open: false, user: null });
      loadData();
    } catch (e) { message.error('操作失败'); }
  }

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '昵称', dataIndex: 'nickname' },
    { title: '手机号', dataIndex: 'phone', render: v => v || '-' },
    { title: '会员等级', dataIndex: 'memberLevel',
      render: v => v === 'chief'
        ? <Tag color="gold" icon={<CrownOutlined />}>大酋长</Tag>
        : <Tag>普通会员</Tag>
    },
    { title: '大酋长到期', dataIndex: 'chiefExpireAt',
      render: v => v ? new Date(v).toLocaleDateString('zh-CN') : '-' },
    { title: '免费亲友', dataIndex: 'chiefFreeGuestUsed',
      render: v => v ? <Tag color="red">已使用</Tag> : <Tag color="green">未使用</Tag> },
    { title: '注册时间', dataIndex: 'createdAt', render: v => new Date(v).toLocaleDateString('zh-CN') },
    { title: '操作', key: 'action',
      render: (_, r) => (
        <Space>
          <Button size="small" icon={<CrownOutlined />}
            onClick={() => setChiefModal({ open: true, user: r })}>
            设置大酋长
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>会员管理</h2>
      <div style={{ marginBottom: 16, display: 'flex', gap: 12 }}>
        <Input placeholder="搜索昵称/手机号" prefix={<SearchOutlined />} style={{ width: 240 }}
          value={keyword} onChange={e => setKeyword(e.target.value)}
          onPressEnter={() => { setPagination(prev => ({ ...prev, current: 1 })); loadData(); }}
        />
        <Select placeholder="会员等级" allowClear style={{ width: 140 }}
          value={memberLevel || undefined}
          onChange={v => { setMemberLevel(v || ''); setPagination(prev => ({ ...prev, current: 1 })); }}
          options={[{ value: 'normal', label: '普通会员' }, { value: 'chief', label: '大酋长' }]}
        />
      </div>
      <Table columns={columns} dataSource={data} rowKey="id" loading={loading}
        pagination={{
          ...pagination,
          showTotal: total => `共 ${total} 位会员`,
          onChange: (page, pageSize) => setPagination({ ...pagination, current: page, pageSize }),
        }}
      />

      <Modal title="设置大酋长" open={chiefModal.open}
        onOk={handleSetChief}
        onCancel={() => setChiefModal({ open: false, user: null })}
      >
        <p>用户：<b>{chiefModal.user?.nickname}</b></p>
        <p>开通月数：</p>
        <InputNumber min={1} max={60} value={chiefMonths} onChange={setChiefMonths} style={{ width: '100%' }} />
      </Modal>
    </div>
  );
}
